import React, { memo, useState } from 'react'
import { Box, Flex, Button, IconButton, HStack, Text } from '@chakra-ui/react'
import { FiThumbsUp, FiThumbsDown, FiZoomIn } from 'react-icons/fi'
import { ImageZoomModal } from './ImageZoomModal'

function ArtImageComponent({ image, imageHeight = '400px', displayType = 'approval', selectedStatus, onApprove, onReject, onSelect, groupId }) {
  const [isZoomOpen, setIsZoomOpen] = useState(false)

  const handleZoom = () => {
    setIsZoomOpen(true)
  }

  const handleCloseZoom = () => {
    setIsZoomOpen(false)
  }

  const isSelected = selectedStatus === 'approve' || (displayType === 'selection' && selectedStatus === image.id)

  return (
    <>
      <Box
        position="relative"
        borderRadius="md"
        overflow="hidden"
        boxShadow={displayType === 'selection' ? 'sm' : 'md'}
        border={displayType === 'selection' && isSelected ? '2px solid' : displayType === 'selection' ? '1px solid' : 'none'}
        borderColor={displayType === 'selection' && isSelected ? '#378BBF' : 'gray.200'}
        _hover={{ borderColor: displayType === 'selection' ? '#378BBF' : undefined }}
      >
        <Box
          as="img"
          src={image.url}
          alt={`Arte ${image.id}`}
          width="100%"
          height={imageHeight}
          objectFit="cover"
          backgroundColor={image.backgroundColor || 'gray.100'}
        />

        <IconButton
          aria-label="Zoom"
          icon={<FiZoomIn />}
          position="absolute"
          top={displayType === 'selection' ? '5px' : '10px'}
          right={displayType === 'selection' ? '5px' : '10px'}
          colorScheme="white"
          backgroundColor="white"
          color="gray.700"
          borderRadius="full"
          size={displayType === 'selection' ? 'xs' : 'sm'}
          onClick={handleZoom}
          _hover={{ backgroundColor: 'gray.200' }}
        />

        {displayType === 'approval' ? (
          <Flex position="absolute" bottom="10px" width="100%" justifyContent="center" gap={2}>
            <Button
              leftIcon={<FiThumbsUp />}
              variant={selectedStatus === 'approve' ? 'solid' : 'outline'}
              colorScheme={selectedStatus === 'approve' ? 'blue' : 'gray'}
              backgroundColor={selectedStatus === 'approve' ? '#378BBF' : 'white'}
              color={selectedStatus === 'approve' ? 'white' : 'gray.700'}
              onClick={() => onApprove(image.id)}
              size="sm"
            >
              Aprovar Arte
            </Button>

            <Button
              leftIcon={<FiThumbsDown />}
              variant={selectedStatus === 'reject' ? 'solid' : 'outline'}
              colorScheme={selectedStatus === 'reject' ? 'red' : 'gray'}
              backgroundColor={selectedStatus === 'reject' ? 'red.500' : 'white'}
              color={selectedStatus === 'reject' ? 'white' : 'gray.700'}
              onClick={() => onReject(image.id)}
              size="sm"
            >
              Rejeitar Arte
            </Button>
          </Flex>
        ) : (
          <Flex
            position="absolute"
            bottom="0"
            width="100%"
            justifyContent="center"
            p={1}
            bg={isSelected ? '#378BBF' : 'blackAlpha.50'}
            onClick={() => onSelect(groupId, image.id)}
            cursor="pointer"
          >
            <HStack spacing={1}>
              <FiThumbsUp color={isSelected ? 'white' : 'gray'} size="12px" />
              <Text fontSize="xs" color={isSelected ? 'white' : 'gray.600'}>
                {isSelected ? 'Aprovado' : 'Aprovar Arte'}
              </Text>
            </HStack>
          </Flex>
        )}
      </Box>

      <ImageZoomModal isOpen={isZoomOpen} onClose={handleCloseZoom} imageUrl={image.url} imageName={`Arte ${image.id}`} />
    </>
  )
}

export const ArtImage = memo(ArtImageComponent)
